module.exports = __webpack_public_path__ + "static/media/seu-perfil-viajante.c5979a10.png";